/**
 * Human-friendly display of a role's internal name (PTV2-1444 follow-up). The internal name is the
 * identity/key (e.g. `PLATFORM_ADMIN`) and is what the API and the role page's identifier show; every
 * other place a user reads a role should show this label (e.g. `Platform Admin`).
 */
export function roleDisplayLabel(name: string): string {
  return name
    .split(/[_\s-]+/)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
